export const CopyrightFooter = ({ className = '', style, ...rest }) => (
	<footer
		className={`w-full flex justify-center text-xs text-gray-400 ${className}`.trim()}
		style={style}
		role="contentinfo"
		{...rest}
	>
		<p className="text-center px-2">
			Derechos Reservados © Centro de Formación Académica {new Date().getFullYear()}
		</p>
	</footer>
);
